import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';

export default function NotFoundPage() {
  const { t } = useTranslation();
  const { user, signIn, loading } = useAuth();
  return (
    <div className="si-wrap">
      <div className="si-card" style={{ width: 420 }}>
        <div className="si-title">{t('notFound.title')}</div>
        <div className="si-sub">{t('notFound.subtitle')}</div>
        {user ? (
          <Link className="btn-si" to="/tasks" style={{ display: 'block', textAlign: 'center', textDecoration: 'none' }}>
            {t('notFound.goToTasks')}
          </Link>
        ) : (
          <button
            className="btn-si"
            type="button"
            disabled={loading}
            onClick={() => {
              void signIn('/tasks');
            }}
            style={{ display: 'block', textAlign: 'center', textDecoration: 'none', width: '100%' }}
          >
            {t('common.signIn')}
          </button>
        )}
      </div>
    </div>
  );
}
